import {isObservable} from 'rxjs';
import {IconUrlConfig} from '../../types/icon-url/icon-url-config.type';
import {IconUrlValue} from '../../types/icon-url/icon-url-value.type';

export function isIconUrlConfig(value: IconUrlValue | undefined): value is IconUrlConfig {
    return typeof value === 'object' && value !== null && !isObservable(value) && 'url' in value;
}
